/**
 * Content objects for every remaining ES hub/info page.
 * Rendered through SpanishContentPage.
 */

export const SPANISH_PAGES = {
  // -----------------------------------------------------------
  // Brand / Trust
  // -----------------------------------------------------------
  'nuestro-equipo': {
    esPath: '/es/nuestro-equipo', enPath: '/our-team',
    metaTitle: 'Nuestro Equipo Dental — Fort Worth Dental',
    metaDescription: 'Conoce a nuestros dentistas, higienistas y personal bilingüe. Más de 35 años de experiencia atendiendo familias hispanas.',
    h1: 'Nuestro Equipo',
    subtitle: 'Dentistas certificados con décadas de experiencia y un personal bilingüe que te recibe con calidez.',
    sections: [
      {
        title: 'Dr. Mund — Diplomado en Implantología',
        body: [
          'Líder del Centro de Implantes Dentales en Fort Worth Dental. Diplomado del American Board of Oral Implantology (ABOI), una credencial que solo posee el 1% de los dentistas en EE.UU.',
          'Más de 25 años de experiencia. Ha colocado más de 10,000 implantes dentales. Especialista en casos complejos: All-on-4, mini implantes, injertos óseos y elevación de seno maxilar.',
        ],
      },
      {
        title: 'Dr. Razo — Odontología Cosmética y Familiar',
        body: 'Especialista en transformaciones de sonrisa, carillas First Fit y blanqueamiento profesional. Habla español con fluidez. Conocido por su trato cálido y explicaciones claras.',
      },
      {
        title: 'Dr. Hiwaidi y Dr. Pham',
        body: 'Equipo experto en endodoncia, cirugía oral y ortodoncia (Invisalign). Cada paciente recibe el especialista adecuado para su caso.',
      },
      {
        title: 'Personal bilingüe',
        body: 'Recepcionistas, higienistas y asistentes dentales que hablan español con fluidez. Desde la primera llamada hasta el seguimiento, te atendemos en tu idioma.',
      },
    ],
    showForm: true,
  },

  'nuestras-oficinas': {
    esPath: '/es/nuestras-oficinas', enPath: '/our-offices',
    metaTitle: 'Nuestras Oficinas — Fort Worth Dental',
    metaDescription: 'Visita nuestra moderna oficina dental en 4620 Citylake Blvd W, Fort Worth, TX 76132. Tecnología avanzada, ambiente cómodo.',
    h1: 'Nuestras Oficinas',
    subtitle: '4620 Citylake Blvd W, Fort Worth, TX 76132 — moderna, accesible y diseñada para tu comodidad.',
    sections: [
      {
        title: 'Tecnología de punta',
        body: 'Radiografías digitales 3D (CBCT), escáneres intraorales para impresiones digitales sin pasta, láser dental, y todas las herramientas modernas para diagnósticos precisos y tratamientos cómodos.',
      },
      {
        title: 'Ambiente cómodo',
        body: 'Salas de tratamiento con TV en el techo, mantas suaves, audífonos, y opciones de sedación para pacientes con ansiedad. Tu comodidad es nuestra prioridad.',
      },
      {
        title: 'Estacionamiento y accesibilidad',
        body: 'Estacionamiento gratuito amplio, acceso para sillas de ruedas, y ubicación céntrica con fácil acceso desde I-20 e I-30.',
      },
      {
        title: 'Horario',
        bullets: [
          'Lunes a Jueves: 8:00 AM – 5:00 PM',
          'Viernes: 8:00 AM – 1:00 PM',
          'Emergencias: atendemos el mismo día',
        ],
      },
    ],
    showForm: false,
  },

  'testimonios': {
    esPath: '/es/testimonios', enPath: '/testimonials',
    metaTitle: 'Testimonios de Pacientes — Fort Worth Dental',
    metaDescription: 'Más de 1,100 reseñas de 5 estrellas en Google. Lee lo que dicen nuestros pacientes hispanos sobre Fort Worth Dental.',
    h1: 'Testimonios',
    subtitle: 'Más de 1,100 reseñas de 5 estrellas en Google — la confianza de las familias de Tarrant County desde 1990.',
    sections: [
      {
        title: 'Lo que dicen nuestros pacientes',
        body: '"El Dr. Mund cambió mi vida. Tenía miedo de los implantes pero todo el equipo me hizo sentir cómoda — explicaron todo en español y los resultados son perfectos." — María G., Fort Worth',
      },
      {
        body: '"Mi hija necesitaba frenos y nos atendieron sin cita. El personal habla español, los precios son honestos y los pagos mensuales hacen todo accesible." — Carlos R., Arlington',
      },
      {
        body: '"Llevamos 8 años trayendo a toda la familia. La limpieza y los exámenes siempre son completos. Los recomiendo 100%." — Familia Hernández, Benbrook',
      },
      {
        title: '¿Quieres dejar tu reseña?',
        body: 'Si has tenido una buena experiencia, nos encantaría que la compartas en Google — ayuda a otras familias a encontrarnos.',
      },
    ],
    showForm: false,
  },

  'formularios-y-finanzas': {
    esPath: '/es/formularios-y-finanzas', enPath: '/form-finances',
    metaTitle: 'Formularios y Finanzas — Fort Worth Dental',
    metaDescription: 'Aceptamos la mayoría de seguros dentales. Planes de pago mensuales sin interés. Descarga nuestros formularios.',
    h1: 'Formularios y Finanzas',
    subtitle: 'Aceptamos la mayoría de seguros dentales y ofrecemos planes de pago mensuales para que la atención dental sea accesible.',
    sections: [
      {
        title: 'Seguros que aceptamos',
        body: 'Aceptamos la mayoría de planes mayores. Si no ves tu seguro, llámanos — frecuentemente trabajamos como proveedor "fuera de red" con beneficios similares.',
        bullets: [
          'Delta Dental',
          'Cigna',
          'Aetna',
          'MetLife',
          'Humana',
          'United Concordia',
          'Guardian',
          'Principal',
          'BlueCross BlueShield',
        ],
      },
      {
        title: 'Sin seguro dental',
        body: 'No te preocupes — ofrecemos planes de membresía interna a partir de $25/mes que cubren limpiezas, exámenes y descuentos en tratamientos. Pregunta por nuestro plan dental Smile Saver.',
      },
      {
        title: 'Planes de pago',
        body: 'Trabajamos con CareCredit y otras opciones de financiamiento que ofrecen planes de pago mensuales sin interés (sujeto a aprobación de crédito). Aprobación rápida en oficina.',
      },
      {
        title: 'Verificación gratuita de seguro',
        body: 'Antes de tu primera cita, verificamos tu cobertura sin costo y te decimos exactamente cuánto pagarás de tu bolsillo. Cero sorpresas.',
      },
    ],
    showForm: true,
  },

  'areas-que-atendemos': {
    esPath: '/es/areas-que-atendemos', enPath: '/areas-we-serve',
    metaTitle: 'Áreas que Atendemos — Fort Worth Dental',
    metaDescription: 'Atendemos Fort Worth, Arlington, Benbrook, Forest Hill, Westover Hills y todo el condado de Tarrant.',
    h1: 'Áreas que Atendemos',
    subtitle: 'Atendemos a familias hispanas en todo el condado de Tarrant y áreas cercanas — más de 53 ciudades.',
    sections: [
      {
        title: 'Ciudades principales',
        bullets: [
          'Fort Worth (76132 y todos los códigos postales)',
          'Arlington',
          'Benbrook',
          'Forest Hill',
          'White Settlement',
          'Westover Hills',
          'Aledo',
          'Crowley',
          'Burleson',
          'Mansfield',
          'Grand Prairie',
          'Weatherford',
        ],
      },
      {
        title: '¿No ves tu ciudad?',
        body: 'Atendemos a pacientes de toda el área metropolitana de DFW. Llámanos — si estás a 30 minutos en coche, vale la pena el viaje por la calidad de atención.',
      },
    ],
    showForm: false,
  },

  'comunicados-de-prensa': {
    esPath: '/es/comunicados-de-prensa', enPath: '/press-releases',
    metaTitle: 'Comunicados de Prensa — Fort Worth Dental',
    metaDescription: 'Noticias y comunicados de prensa de Fort Worth Dental — premios, nuevas tecnologías y eventos comunitarios.',
    h1: 'Comunicados de Prensa',
    subtitle: 'Noticias, premios y anuncios de Fort Worth Dental.',
    sections: [
      {
        title: 'Best of Fort Worth 2025',
        body: 'Por cuarta vez Fort Worth Dental fue reconocido como Mejor Consultorio Dental por el Fort Worth Star-Telegram — gracias a las miles de familias que votaron por nosotros.',
      },
      {
        title: 'Nuevo: Carillas First Fit',
        body: 'Fort Worth Dental es uno de los primeros consultorios en Texas en ofrecer carillas First Fit — sonrisa nueva en solo 2 horas, con tecnología digital de última generación.',
      },
    ],
    showForm: false,
  },

  // -----------------------------------------------------------
  // Implant Center (hub + 5 sub-pages)
  // -----------------------------------------------------------
  'centro-de-implantes': {
    esPath: '/es/centro-de-implantes', enPath: '/implant-center',
    metaTitle: 'Centro de Implantes Dentales en Fort Worth | Fort Worth Dental',
    metaDescription: 'Centro especializado en implantes dentales con el Dr. Mund — Diplomado del American Board of Oral Implantology. Más de 10,000 implantes colocados.',
    h1: 'Centro de Implantes Dentales',
    subtitle: 'Consultorio especializado en implantes liderado por el Dr. Mund — Diplomado del ABOI con más de 25 años de experiencia.',
    sections: [
      {
        title: 'Implantes dentales (estándar)',
        body: 'Reemplaza un diente individual o varios — postes de titanio osteointegrados que duran décadas y se ven 100% naturales.',
      },
      {
        title: 'Mini implantes dentales',
        body: 'Alternativa de menor costo y procedimiento simplificado — ideal para anclar dentaduras o casos con menos hueso disponible.',
      },
      {
        title: 'Injertos óseos y elevación de seno',
        body: 'Procedimientos avanzados para reconstruir hueso perdido y permitir la colocación segura de implantes en casos complejos.',
      },
      {
        title: 'Odontología cosmética',
        body: 'Combinamos implantes con carillas, blanqueamiento y diseño de sonrisa para resultados cosméticos completos.',
      },
      {
        title: 'Plan dental accesible',
        body: 'Plan dental interno que hace los implantes accesibles para pacientes sin seguro — pregunta por las opciones.',
      },
    ],
    showForm: true,
  },
  'centro-de-implantes/implantes-dentales': {
    esPath: '/es/centro-de-implantes/implantes-dentales', enPath: '/implant-center/dental-implants',
    metaTitle: 'Implantes Dentales — Centro de Implantes Fort Worth Dental',
    metaDescription: 'Implantes dentales colocados por el Dr. Mund, Diplomado del ABOI. Consulta gratis con radiografías 3D.',
    h1: 'Implantes Dentales',
    subtitle: 'El estándar moderno para reemplazar dientes perdidos — colocados por un especialista certificado.',
    sections: [
      { title: '¿Qué son los implantes?', body: 'Un poste de titanio que reemplaza la raíz del diente perdido. Sobre el poste se coloca una corona de porcelana indistinguible de un diente natural.' },
      { title: 'Beneficios', body: 'Duraderos (décadas), preservan el hueso, no dañan dientes vecinos, función completa para masticar, apariencia 100% natural.' },
      { title: 'Proceso', body: 'Consulta gratuita → planificación 3D → colocación del poste (1-2 hrs) → 3-4 meses de osteointegración → colocación de la corona definitiva. Sin dolor con anestesia local.' },
    ],
    showForm: true,
  },
  'centro-de-implantes/mini-implantes': {
    esPath: '/es/centro-de-implantes/mini-implantes', enPath: '/implant-center/mini-dental-implants',
    metaTitle: 'Mini Implantes Dentales en Fort Worth | Fort Worth Dental',
    metaDescription: 'Mini implantes dentales — alternativa de menor costo y procedimiento simplificado. Ideal para anclar dentaduras.',
    h1: 'Mini Implantes Dentales',
    subtitle: 'Alternativa de menor costo a los implantes estándar — colocación más rápida y menos invasiva.',
    sections: [
      { title: '¿Cuándo son ideales?', body: 'Pacientes con poco hueso disponible, presupuestos limitados, o que necesitan anclar una dentadura existente para mayor estabilidad.' },
      { title: 'Ventajas', body: 'Costo menor, colocación en una sola visita, sin necesidad de injertos óseos en muchos casos, recuperación más rápida.' },
    ],
    showForm: true,
  },
  'centro-de-implantes/injerto-mandibular': {
    esPath: '/es/centro-de-implantes/injerto-mandibular', enPath: '/implant-center/jawbone-grafting-and-sinus-lift',
    metaTitle: 'Injerto Mandibular y Elevación de Seno | Fort Worth Dental',
    metaDescription: 'Injertos óseos avanzados y elevación de seno para preparar la mandíbula para implantes en casos complejos.',
    h1: 'Injerto Mandibular y Elevación de Seno',
    subtitle: 'Procedimientos avanzados para casos en los que falta hueso en la mandíbula superior — habilita implantes que de otra forma no serían posibles.',
    sections: [
      { title: 'Elevación de seno maxilar', body: 'Procedimiento para crear espacio óseo bajo el seno maxilar y permitir la colocación de implantes en la zona posterior superior.' },
      { title: 'Injerto óseo de bloque', body: 'Para casos con pérdida ósea severa — usamos hueso del propio paciente o material biocompatible para reconstruir el volumen necesario.' },
    ],
    showForm: true,
  },
  'centro-de-implantes/odontologia-cosmetica': {
    esPath: '/es/centro-de-implantes/odontologia-cosmetica', enPath: '/implant-center/cosmetic-dentistry-at-fort-worth-dental',
    metaTitle: 'Odontología Cosmética — Centro de Implantes Fort Worth Dental',
    metaDescription: 'Combinamos implantes con odontología cosmética avanzada — diseño de sonrisa completo en un solo lugar.',
    h1: 'Odontología Cosmética en el Centro de Implantes',
    subtitle: 'Implantes + carillas + blanqueamiento — diseño de sonrisa integral en un solo consultorio.',
    sections: [
      { title: 'Diseño de sonrisa completo', body: 'Combinamos implantes para reemplazar dientes faltantes con carillas o blanqueamiento para perfeccionar el resto de tu sonrisa — una sola transformación cohesiva.' },
    ],
    showForm: true,
  },
  'centro-de-implantes/plan-dental': {
    esPath: '/es/centro-de-implantes/plan-dental', enPath: '/implant-center/fort-worth-dental-provides-a-dental-plan-you-can-afford',
    metaTitle: 'Plan Dental Accesible | Fort Worth Dental',
    metaDescription: 'Plan dental interno mensual para pacientes sin seguro. Limpiezas, exámenes y descuentos en tratamientos a partir de $25/mes.',
    h1: 'Plan Dental Accesible',
    subtitle: 'Sin seguro dental, sin problema. Nuestro plan interno hace la atención dental accesible para todas las familias.',
    sections: [
      { title: 'Plan Smile Saver', body: 'A partir de $25/mes incluye 2 limpiezas anuales, 2 exámenes, radiografías rutinarias y descuentos del 15-20% en todos los tratamientos.' },
      { title: 'Sin restricciones de seguro', body: 'No hay periodos de espera, ni preautorizaciones, ni reclamos. Te inscribes y empiezas a usarlo el mismo día.' },
    ],
    showForm: true,
  },

  // -----------------------------------------------------------
  // Promociones detail pages (5 sub-pages)
  // -----------------------------------------------------------
  'promociones/implantes-consulta-gratis': {
    esPath: '/es/promociones/implantes-consulta-gratis', enPath: '/dental-implants-free-consult-with-x-rays',
    metaTitle: 'Consulta GRATIS de Implantes Dentales con Radiografías',
    metaDescription: 'Consulta inicial GRATIS con radiografías 3D y plan de tratamiento personalizado — valor de $475.',
    h1: 'Consulta GRATIS de Implantes Dentales',
    subtitle: 'Valor $475. Para nuevos pacientes considerando implantes dentales.',
    sections: [
      { title: '¿Qué incluye?', bullets: ['Examen clínico completo', 'Radiografías 3D (CBCT)', 'Evaluación de hueso disponible', 'Plan de tratamiento personalizado', 'Estimado claro de costos'] },
      { title: 'Sin compromiso', body: 'La consulta es gratuita y sin obligación. Solo si decides proceder con el tratamiento, comienzan los costos.' },
    ],
    showForm: true,
  },
  'promociones/invisalign-consulta-gratis': {
    esPath: '/es/promociones/invisalign-consulta-gratis', enPath: '/invisalign-free-consultation',
    metaTitle: 'Consulta GRATIS de Invisalign en Fort Worth',
    metaDescription: 'Escaneo digital gratis y vista previa de tu sonrisa final con Invisalign. Sin compromiso.',
    h1: 'Consulta GRATIS de Invisalign®',
    subtitle: 'Escaneo digital 3D + vista previa de tu sonrisa final — sin costo, sin compromiso.',
    sections: [
      { title: '¿Qué incluye?', bullets: ['Escaneo digital intraoral 3D', 'Vista previa virtual de cómo lucirá tu sonrisa final', 'Plan de tratamiento personalizado', 'Estimado claro de costos y duración'] },
    ],
    showForm: true,
  },
  'promociones/limpieza-179': {
    esPath: '/es/promociones/limpieza-179', enPath: '/179-healthy-cleaning-exam-and-set-of-x-rays',
    metaTitle: 'Limpieza Dental + Examen + Radiografías por $199',
    metaDescription: 'Especial para nuevos pacientes — limpieza completa, examen y radiografías digitales por solo $199.',
    h1: 'Limpieza + Examen + Radiografías por $199',
    subtitle: 'Especial para nuevos pacientes — ahorras más de $150.',
    sections: [
      { title: 'Este paquete incluye', bullets: ['Limpieza dental profesional — Eliminamos placa y sarro', 'Examen oral integral — Revisión completa de dientes, encías y tejidos orales', 'Set completo de radiografías — Radiografías digitales para detectar problemas ocultos', 'Detección de cáncer oral — La detección temprana salva vidas', 'Plan de tratamiento — Recomendaciones personalizadas para una salud oral óptima'] },
      { title: 'Solo para pacientes sanos', body: 'Este precio aplica a pacientes sin condiciones que requieran tratamiento adicional. Si necesitas tratamiento adicional, te lo notificamos antes de proceder.' },
    ],
    showForm: true,
  },
  'promociones/emergencia-99': {
    esPath: '/es/promociones/emergencia-99', enPath: '/99-emergency-exam-and-x-ray-affordable-dental-services',
    metaTitle: 'Emergencia Dental — Examen + Radiografía por $99',
    metaDescription: 'Atención dental de emergencia en Fort Worth. Examen + radiografía por solo $99. Citas el mismo día.',
    h1: 'Emergencia Dental — Examen + Radiografía $99',
    subtitle: 'Atención el mismo día. Diagnóstico rápido y plan de tratamiento claro antes de proceder.',
    sections: [
      { title: 'Atendemos todas las emergencias', bullets: ['Dolor de muela severo', 'Diente roto o astillado', 'Diente caído por golpe', 'Absceso o infección', 'Corona o empaste perdido'] },
      { title: 'No esperes', body: 'Las emergencias dentales empeoran rápido. Llámanos ahora al (817) 985-3337 y agendamos atención el mismo día.' },
    ],
    showForm: true,
  },
  'promociones/lanap-consulta-gratis': {
    esPath: '/es/promociones/lanap-consulta-gratis', enPath: '/free-lanap-consultation',
    metaTitle: 'Consulta LANAP® GRATIS en Fort Worth',
    metaDescription: 'Consulta gratis para LANAP® — alternativa láser a la cirugía tradicional de encías. Aprobada por la FDA.',
    h1: 'Consulta LANAP® GRATIS',
    subtitle: 'Alternativa láser mínimamente invasiva a la cirugía tradicional de encías.',
    sections: [
      { title: '¿Qué evalúa la consulta?', bullets: ['Severidad de la enfermedad periodontal', 'Si LANAP® es apropiado para tu caso', 'Plan de tratamiento personalizado', 'Estimado claro de costos'] },
    ],
    showForm: true,
  },

  // -----------------------------------------------------------
  // SEO landing pages (cost / near-me / location)
  // -----------------------------------------------------------
  'costo-implantes-dentales-fort-worth': {
    esPath: '/es/costo-implantes-dentales-fort-worth', enPath: '/dental-implant-cost-fort-worth',
    showMatcher: true,
    metaTitle: 'Costo de Implantes Dentales en Fort Worth | Cotización Personalizada',
    metaDescription: 'Cada caso de implante dental es único. Recibe una cotización personalizada por escrito en tu consulta GRATIS (incluye radiografías 3D — valor de $475). Financiamiento disponible.',
    h1: 'Costo de Implantes Dentales en Fort Worth',
    subtitle: 'Cada caso es único — recibe una cotización personalizada por escrito en tu consulta GRATIS.',
    sections: [
      { title: '¿Cuánto cuesta un implante dental?', body: 'El costo depende del número de implantes, la salud ósea y el tipo de restauración — cada caso es único. En lugar de publicar precios que pueden no aplicar a tu situación, Fort Worth Dental te da una cotización exacta por escrito en tu consulta GRATIS (valor de $475). Llama al (817) 985-3337 para agendar.' },
      { title: 'Factores que afectan el costo', bullets: ['Cantidad de implantes', 'Si necesitas injerto óseo previo', 'Tipo de corona (porcelana, zirconia)', 'Complejidad del caso', 'Ubicación en la boca'] },
      { title: 'Financiamiento disponible', body: 'CareCredit y otros planes ofrecen pagos mensuales sin interés (con aprobación). Aprobación en oficina en menos de 5 minutos.' },
    ],
    showForm: true,
  },
  'implantes-dentales-economicos-fort-worth': {
    esPath: '/es/implantes-dentales-economicos-fort-worth', enPath: '/affordable-dental-implants-fort-worth',
    showMatcher: true,
    metaTitle: 'Implantes Dentales Económicos en Fort Worth | Financiamiento 0% | Fort Worth Dental',
    metaDescription: 'Implantes dentales económicos en Fort Worth, TX con financiamiento sin interés, pagos mensuales bajos, seguro maximizado y plan dental de $199/año. Cotización personalizada en tu consulta GRATIS. Llama al (817) 985-3337.',
    h1: 'Implantes Dentales Económicos en Fort Worth',
    subtitle: 'Una nueva sonrisa no tiene que costarte todo. Con financiamiento sin interés, pagos mensuales bajos y tu seguro maximizado, los implantes dentales de calidad están a tu alcance — colocados por un especialista certificado.',
    sections: [
      { title: 'Implantes de Calidad que se Ajustan a tu Presupuesto', body: '"Económico" no significa un implante de baja calidad — significa un plan de tratamiento que funciona para tu vida. En lugar de publicar un precio genérico que no aplica a tu caso, te damos una cotización por escrito y un plan de pagos que realmente puedes pagar. Tus implantes los coloca el Dr. Mund, Diplomado del Consejo Americano de Implantología Oral. El implante más económico es el que se hace bien la primera vez.' },
      { title: '4 Formas en que Hacemos los Implantes Accesibles', bullets: ['Financiamiento 0% de interés (CareCredit y LendingClub) con pagos mensuales bajos', 'Maximizamos tu seguro PPO — verificamos beneficios y presentamos tus reclamos', 'Plan dental interno de $199/año — sin deducibles ni periodos de espera', 'Aceptamos HSA / FSA para estirar tu presupuesto'] },
      { title: 'Implantes Dentales Económicos Cerca de Ti', body: 'Pacientes de Fort Worth, Arlington, Benbrook, Lake Worth, Aledo, White Settlement, Keller y todo el condado de Tarrant nos visitan para recibir atención de implantes accesible y experta. Tu consulta es GRATIS (valor de $475) e incluye escaneo 3D, radiografías y un plan de tratamiento por escrito con tus opciones de pago.' },
      { title: '¿Cómo obtengo implantes dentales económicos en Fort Worth?', body: 'Hacemos los implantes accesibles con financiamiento sin interés, planes de pago internos, un plan dental de $199/año, HSA/FSA y maximizando tu seguro PPO. Recibes una cotización personalizada y un pago mensual bajo en una consulta GRATIS. Llama al (817) 985-3337.' },
    ],
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Dentist',
          'name': 'Fort Worth Dental',
          'url': 'https://fortworthdental.com/es/implantes-dentales-economicos-fort-worth',
          'telephone': '+18179853337',
          'priceRange': '$$',
          'address': {
            '@type': 'PostalAddress',
            'streetAddress': '4620 Citylake Blvd W',
            'addressLocality': 'Fort Worth',
            'addressRegion': 'TX',
            'postalCode': '76132',
            'addressCountry': 'US',
          },
          'aggregateRating': { '@type': 'AggregateRating', 'ratingValue': '4.9', 'reviewCount': '1100' },
        },
        {
          '@type': 'FAQPage',
          'inLanguage': 'es-US',
          'mainEntity': [
            { '@type': 'Question', 'name': '¿Cómo obtengo implantes dentales económicos en Fort Worth?', 'acceptedAnswer': { '@type': 'Answer', 'text': 'Hacemos los implantes accesibles con financiamiento 0% de interés (CareCredit, LendingClub), planes de pago internos, un plan dental de $199/año, HSA/FSA y maximizando tu seguro PPO. Recibes una cotización personalizada y un pago mensual bajo en una consulta GRATIS. Llama al (817) 985-3337.' } },
            { '@type': 'Question', 'name': '¿Los implantes dentales económicos son de menor calidad?', 'acceptedAnswer': { '@type': 'Answer', 'text': 'No. Económico significa un plan de tratamiento que se ajusta a tu presupuesto, no un implante más barato. Tus implantes los coloca el Dr. Mund, Diplomado del Consejo Americano de Implantología Oral (el 1% de los dentistas de implantes).' } },
            { '@type': 'Question', 'name': '¿Puedo financiar implantes dentales con pagos mensuales bajos?', 'acceptedAnswer': { '@type': 'Answer', 'text': 'Sí. Ofrecemos financiamiento 0% de interés a través de CareCredit y LendingClub, además de planes de pago internos, para que tu inversión se convierta en un pago mensual cómodo. La aprobación suele tomar solo unos minutos en la oficina.' } },
          ],
        },
      ],
    },
    showForm: true,
  },
  'costo-invisalign-fort-worth': {
    esPath: '/es/costo-invisalign-fort-worth', enPath: '/invisalign-cost-fort-worth',
    metaTitle: 'Costo de Invisalign en Fort Worth | Cotización Personalizada',
    metaDescription: 'Cada caso de Invisalign es único. Recibe una cotización personalizada por escrito en tu consulta GRATIS. Pagos mensuales y financiamiento sin interés.',
    h1: 'Costo de Invisalign® en Fort Worth',
    subtitle: 'Cada caso es único — recibe una cotización personalizada en tu consulta GRATIS de Invisalign.',
    sections: [
      { title: '¿Cuánto cuesta Invisalign?', body: 'El costo de Invisalign depende de la complejidad de tu mordida, el número de aligners necesarios y la duración del tratamiento. En Fort Worth Dental ofrecemos consulta GRATIS con escaneo digital, vista previa de tu sonrisa final y una cotización personalizada por escrito — sin compromiso.' },
      { title: '¿Lo cubre el seguro?', body: 'Muchos planes dentales cubren Invisalign como ortodoncia. Verificamos tu cobertura sin costo y te informamos exactamente cuánto pagarás de tu bolsillo antes de comenzar.' },
    ],
    showForm: true,
  },
  'mejores-dentistas-fort-worth': {
    esPath: '/es/mejores-dentistas-fort-worth', enPath: '/top-dentists-fort-worth',
    metaTitle: 'Mejores Dentistas en Fort Worth | Fort Worth Dental',
    metaDescription: 'Reconocidos como mejor consultorio dental de Fort Worth — Best of 2025. Más de 1,100 reseñas de 5 estrellas.',
    h1: 'Mejores Dentistas en Fort Worth',
    subtitle: 'Reconocidos como Best of Fort Worth 2020, 2021, 2023 y 2025 — la elección de las familias hispanas.',
    sections: [
      { title: '¿Por qué nos eligen?', bullets: ['Más de 35 años de experiencia', 'Más de 1,100 reseñas de 5 estrellas en Google', 'Personal 100% bilingüe', 'Tecnología de punta (3D, láser, escáneres digitales)', 'Atendemos sin cita para emergencias', 'Aceptamos la mayoría de seguros'] },
    ],
    showForm: true,
  },
  'implantes-dentales-fort-worth': {
    esPath: '/es/implantes-dentales-fort-worth', enPath: '/dental-implants-fort-worth',
    showMatcher: true,
    metaTitle: 'Implantes Dentales en Fort Worth | Centro de Implantes',
    metaDescription: 'Centro especializado en implantes dentales en Fort Worth con el Dr. Mund — Diplomado del ABOI. Consulta gratis.',
    h1: 'Implantes Dentales en Fort Worth',
    subtitle: 'Centro especializado en implantes liderado por el Dr. Mund — más de 10,000 implantes colocados.',
    sections: [
      { title: '¿Por qué Fort Worth Dental para tus implantes?', bullets: ['Dr. Mund — Diplomado del ABOI (1% de los dentistas en EE.UU.)', 'Más de 10,000 implantes colocados', 'Tecnología 3D para planificación precisa', 'Consulta gratuita con radiografías', 'Financiamiento mensual disponible'] },
    ],
    showForm: true,
  },
  'dentista-cerca-de-mi': {
    esPath: '/es/dentista-cerca-de-mi', enPath: '/dentist-near-me',
    metaTitle: 'Dentista Cerca de Mí en Fort Worth | Fort Worth Dental',
    metaDescription: 'Atendemos Fort Worth, Arlington, Benbrook y todo Tarrant County. Consulta gratis. Aceptamos seguro.',
    h1: 'Dentista Cerca de Mí',
    subtitle: 'Si vives en Fort Worth o Tarrant County — somos tu dentista cercano. Atendemos a más de 53 ciudades.',
    sections: [
      { title: 'Atendemos todo Tarrant County', body: 'Desde Fort Worth hasta Arlington, Benbrook, Forest Hill, White Settlement, Westover Hills y muchas más. Si estás a 30 minutos en coche, vale la pena el viaje.' },
    ],
    showForm: true,
  },
  'mejor-dentista-fort-worth': {
    esPath: '/es/mejor-dentista-fort-worth', enPath: '/best-dentist-fort-worth',
    metaTitle: 'Mejor Dentista en Fort Worth | Fort Worth Dental',
    metaDescription: 'Reconocidos como mejor dentista de Fort Worth 4 años seguidos. Más de 1,100 reseñas de 5 estrellas.',
    h1: 'Mejor Dentista en Fort Worth',
    subtitle: 'Best of Fort Worth 2020, 2021, 2023 y 2025 — Fort Worth Star-Telegram.',
    sections: [
      { title: 'Lo que nos hace los mejores', body: 'Combinación de experiencia (35+ años), tecnología avanzada, personal bilingüe, atención compasiva y precios honestos. Pero los reconocimientos son solo papel — los testimonios de nuestros pacientes son la verdadera medida.' },
    ],
    showForm: true,
  },
  'mejor-dentista-cerca-de-mi': {
    esPath: '/es/mejor-dentista-cerca-de-mi', enPath: '/best-dentist-near-me',
    metaTitle: 'Mejor Dentista Cerca de Mí | Fort Worth Dental',
    metaDescription: 'El mejor dentista cerca de ti en Fort Worth. Best of 2025. Más de 1,100 reseñas. Hablamos español.',
    h1: 'Mejor Dentista Cerca de Mí',
    subtitle: 'Si buscas el mejor dentista cerca de Fort Worth o Tarrant County, has llegado al lugar correcto.',
    sections: [
      { title: '¿Cómo elegir un dentista?', bullets: ['Reseñas verificadas (1,100+ de 5 estrellas en Google)', 'Reconocimientos profesionales (Best of Fort Worth)', 'Especialistas certificados (Dr. Mund — ABOI)', 'Personal bilingüe', 'Tecnología moderna', 'Precios transparentes'] },
    ],
    showForm: true,
  },
  'dentista-cerca-de-benbrook': {
    esPath: '/es/dentista-cerca-de-benbrook', enPath: '/dentist-near-benbrook',
    metaTitle: 'Dentista Cerca de Benbrook | Fort Worth Dental',
    metaDescription: 'Dentista cerca de Benbrook, TX. Solo 10 minutos desde el centro de Benbrook. Consulta gratis. Hablamos español.',
    h1: 'Dentista Cerca de Benbrook',
    subtitle: 'Solo 10 minutos desde Benbrook — atención dental de calidad para familias de Benbrook desde 1990.',
    sections: [
      { title: 'Cerca, conveniente y accesible', body: 'Fort Worth Dental está a solo 10 minutos en coche desde el centro de Benbrook por la US-377. Estacionamiento gratuito y citas flexibles para tu horario.' },
    ],
    showForm: true,
  },
  'dentista-cerca-de-aledo': {
    esPath: '/es/dentista-cerca-de-aledo', enPath: '/dentist-near-aledo',
    metaTitle: 'Dentista Cerca de Aledo | Fort Worth Dental',
    metaDescription: 'Dentista cerca de Aledo, TX. Atención dental experta para familias de Aledo. Hablamos español.',
    h1: 'Dentista Cerca de Aledo',
    subtitle: 'Atención dental confiable para familias de Aledo y áreas cercanas.',
    sections: [
      { title: 'Cerca de Aledo', body: 'Fort Worth Dental atiende a numerosas familias de Aledo. Solo 20 minutos en coche por la I-30, con todos los servicios bajo un solo techo.' },
    ],
    showForm: true,
  },
  'dentista-cerca-de-westover-hills': {
    esPath: '/es/dentista-cerca-de-westover-hills', enPath: '/dentist-near-westover-hills',
    metaTitle: 'Dentista Cerca de Westover Hills | Fort Worth Dental',
    metaDescription: 'Dentista cerca de Westover Hills, TX. Atención dental personalizada y de calidad. Hablamos español.',
    h1: 'Dentista Cerca de Westover Hills',
    subtitle: 'Atención dental cercana a Westover Hills — experiencia, tecnología y trato personalizado.',
    sections: [
      { title: 'Cerca y conveniente', body: 'Fort Worth Dental está convenientemente ubicado para familias de Westover Hills — corto trayecto, fácil acceso, calidad excepcional.' },
    ],
    showForm: true,
  },

  // -----------------------------------------------------------
  // Legal pages
  // -----------------------------------------------------------
  'terminos': {
    esPath: '/es/terminos', enPath: '/terms',
    metaTitle: 'Términos y Condiciones — Fort Worth Dental',
    metaDescription: 'Términos y condiciones de uso del sitio web de Fort Worth Dental.',
    h1: 'Términos y Condiciones',
    subtitle: 'Última actualización: enero 2026',
    sections: [
      { title: 'Aceptación de los términos', body: 'Al acceder y usar este sitio web, aceptas cumplir con los siguientes términos y condiciones. Si no estás de acuerdo, no uses este sitio.' },
      { title: 'Información médica', body: 'La información en este sitio es solo educativa y no reemplaza el consejo médico profesional. Siempre consulta a tu dentista para diagnósticos y tratamientos personalizados.' },
      { title: 'Propiedad intelectual', body: 'Todo el contenido (texto, imágenes, logos, gráficos) es propiedad de Fort Worth Dental y está protegido por derechos de autor. No se permite reproducción sin autorización por escrito.' },
      { title: 'Limitación de responsabilidad', body: 'Fort Worth Dental no se hace responsable por errores u omisiones en el contenido. Usamos este sitio bajo tu propio riesgo.' },
      { title: 'Cambios a estos términos', body: 'Podemos actualizar estos términos en cualquier momento. La fecha de la última actualización aparece en la parte superior.' },
    ],
  },
  'privacidad': {
    esPath: '/es/privacidad', enPath: '/privacy',
    metaTitle: 'Política de Privacidad — Fort Worth Dental',
    metaDescription: 'Política de privacidad de Fort Worth Dental — cómo recopilamos, usamos y protegemos tu información.',
    h1: 'Política de Privacidad',
    subtitle: 'Última actualización: enero 2026',
    sections: [
      { title: 'Información que recopilamos', body: 'Recopilamos información que nos proporcionas voluntariamente (nombre, correo, teléfono, información médica) cuando solicitas una cita o nos contactas. También recopilamos información técnica básica (cookies, dirección IP) para mejorar el sitio.' },
      { title: 'Cómo usamos tu información', body: 'Usamos tu información para responder a tus consultas, agendar citas, brindarte atención dental, enviarte recordatorios, y cumplir con regulaciones legales (HIPAA).' },
      { title: 'Protección de tu información', body: 'Implementamos medidas técnicas y administrativas razonables para proteger tu información. Toda la información médica está protegida bajo HIPAA.' },
      { title: 'Compartir información', body: 'No vendemos ni compartimos tu información personal con terceros, excepto cuando es necesario para brindarte atención (laboratorios, especialistas) o lo requiere la ley.' },
      { title: 'Tus derechos', body: 'Tienes derecho a acceder, corregir o solicitar la eliminación de tu información personal. Contáctanos para ejercer estos derechos.' },
    ],
  },
  'hipaa': {
    esPath: '/es/hipaa', enPath: '/hipaa-npp',
    metaTitle: 'Aviso HIPAA de Privacidad — Fort Worth Dental',
    metaDescription: 'Aviso HIPAA de Prácticas de Privacidad de Fort Worth Dental — cómo protegemos tu información médica.',
    h1: 'Aviso HIPAA de Prácticas de Privacidad',
    subtitle: 'Cómo Fort Worth Dental protege tu información médica protegida (PHI).',
    sections: [
      { title: 'Tu información médica', body: 'Como paciente, tienes derechos federales sobre tu información médica protegida (PHI) bajo la ley HIPAA. Este aviso describe cómo usamos y protegemos tu PHI.' },
      { title: 'Usos permitidos', body: 'Usamos tu PHI para tratamiento (atención dental), pago (facturación de seguros) y operaciones (gestión interna). Cualquier otro uso requiere tu autorización por escrito.' },
      { title: 'Tus derechos HIPAA', bullets: ['Solicitar copias de tu expediente', 'Solicitar correcciones', 'Recibir un listado de divulgaciones', 'Solicitar comunicaciones confidenciales', 'Presentar una queja sin represalia'] },
    ],
  },
  'mapa-del-sitio': {
    esPath: '/es/mapa-del-sitio', enPath: '/sitemap',
    metaTitle: 'Mapa del Sitio — Fort Worth Dental',
    metaDescription: 'Mapa del sitio en español de Fort Worth Dental — todas las páginas organizadas por sección.',
    h1: 'Mapa del Sitio',
    subtitle: 'Todas las páginas de Fort Worth Dental en español, organizadas para que encuentres lo que buscas.',
    sections: [
      { title: 'Páginas principales', bullets: ['Inicio (/es)', 'Sobre Nosotros (/es/sobre-nosotros)', 'Nuestras Oficinas (/es/nuestras-oficinas)', 'Nuestro Equipo (/es/nuestro-equipo)', 'Contacto (/es/contacto)', 'Testimonios (/es/testimonios)', 'Áreas que Atendemos (/es/areas-que-atendemos)'] },
      { title: 'Servicios', bullets: ['Servicios completos (/es/servicios)', 'Implantes Dentales (/es/implantes-dentales)', 'Invisalign (/es/invisalign)', 'Blanqueamiento (/es/blanqueamiento-dental)', 'Endodoncia (/es/endodoncia)', 'Emergencia (/es/dentista-de-emergencia)', 'Odontología Cosmética (/es/odontologia-cosmetica)'] },
      { title: 'Promociones', bullets: ['Todas las promociones (/es/promociones)', 'Implantes Consulta Gratis', 'Invisalign Consulta Gratis', 'Limpieza $199', 'Emergencia $99'] },
      { title: 'Centro de Implantes', bullets: ['Centro de Implantes (/es/centro-de-implantes)', 'Implantes Dentales', 'Mini Implantes', 'Injerto Mandibular'] },
      { title: 'Información', bullets: ['Formularios y Finanzas (/es/formularios-y-finanzas)', 'Comunicados de Prensa (/es/comunicados-de-prensa)', 'Noticias Dentales (/es/blog)'] },
      { title: 'Legal', bullets: ['Términos y Condiciones (/es/terminos)', 'Política de Privacidad (/es/privacidad)', 'Aviso HIPAA (/es/hipaa)'] },
    ],
  },
};
